document.addEventListener('DOMContentLoaded', function () {
    class FaqSection extends HTMLElement {
      constructor() {
        super();
        this.questions = this.querySelectorAll('.faq-question');
  
        this.questions.forEach((question) => {
          const answer = question.querySelector('.question-answer');
          answer.style.maxHeight = '0';
          answer.style.overflow = 'hidden';
  
          question.querySelector('.question-upper-part').addEventListener('click', () => {
            this.toggleAnswer(question);
          });
        });
      }
  
      toggleAnswer(question) {
        const answer = question.querySelector('.question-answer');
        const iconPath = question.querySelector('.faq-icon path');
  
        question.classList.toggle('active');
  
        if (question.classList.contains('active')) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
          iconPath.setAttribute('d', 'M18 12.5H6C5.72386 12.5 5.5 12.2761 5.5 12V11.5C5.5 11.2239 5.72386 11 6 11H18C18.2761 11 18.5 11.2239 18.5 11.5V12C18.5 12.2761 18.2761 12.5 18 12.5Z'); // Change icon to minus
        } else {
          answer.style.maxHeight = '0'; // Collapse answer
          iconPath.setAttribute('d', 'M18 12.5V13C18 13.2761 17.7762 13.5 17.5 13.5H11.75V19.25C11.75 19.5261 11.5261 19.75 11.25 19.75H10.75C10.4739 19.75 10.25 19.5261 10.25 19.25V13.5H4.5C4.22386 13.5 4 13.2761 4 13V12.5C4 12.2239 4.22386 12 4.5 12H10.25V6.25C10.25 5.97385 10.4739 5.75 10.75 5.75H11.25C11.5261 5.75 11.75 5.97385 11.75 6.25V12H17.5C17.7762 12 18 12.2239 18 12.5Z'); // Change icon to plus
        }
      }
    }
  
    customElements.define('faq-section', FaqSection);
  });